import React from 'react';
import { MessageCircle } from 'lucide-react';
import { ConversationSidebar } from '@/components/conversation/ConversationSidebar';
import { useConversation } from '@/contexts/ConversationContext';

interface SplitScreenLayoutProps {
  children: React.ReactNode;
  onEventCreated?: (eventData: any) => void;
}

export const SplitScreenLayout: React.FC<SplitScreenLayoutProps> = ({ 
  children, 
  onEventCreated 
}) => {
  const { isConversationVisible, showConversationBubble, openConversation, closeConversation } = useConversation();

  return (
    <div className="h-[calc(100vh-5rem)] flex">
      {/* Conversation Sidebar */}
      {isConversationVisible && (
        <div className="w-80 flex-shrink-0">
          <ConversationSidebar
            onEventCreated={onEventCreated}
            onClose={closeConversation}
          />
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        {children}
      </div>

      {/* Minimized Conversation Button */}
      {showConversationBubble && (
        <div className="fixed left-4 bottom-4 z-50">
          <button
            onClick={openConversation}
            className="bg-purple-600 hover:bg-purple-700 text-white rounded-full p-3 shadow-lg transition-colors"
            title="Open Chat Assistant"
          >
            <MessageCircle className="h-6 w-6" />
          </button>
        </div>
      )}
    </div>
  );
};
